import { render } from "./Document.vue?vue&type=template&id=04790f6a"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QEditor});
